var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: { size: "auto", title: "Send custom push notification" },
      model: {
        value: _vm.sendNotificationModal.visible,
        callback: function($$v) {
          _vm.$set(_vm.sendNotificationModal, "visible", $$v)
        },
        expression: "sendNotificationModal.visible"
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    error: !_vm.$v.payload.message.maxLength,
                    "error-label": "178 character limit"
                  }
                },
                [
                  _c("q-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      inverted: "",
                      placeholder: "Enter the message here"
                    },
                    model: {
                      value: _vm.payload.message,
                      callback: function($$v) {
                        _vm.$set(_vm.payload, "message", $$v)
                      },
                      expression: "payload.message"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "row justify-content-between" },
          [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("q-btn", {
                  attrs: { rounded: "", label: "Cancel", color: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                })
              ],
              1
            ),
            _c("q-btn", {
              attrs: {
                disable: _vm.$v.payload.message.$invalid,
                rounded: "",
                color: "primary",
                label: "Send"
              },
              on: {
                click: function($event) {
                  _vm.sendNotification()
                }
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }